import React, { useEffect, useState } from 'react';
import { ClockIcon } from './Icons';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 w-full z-50 bg-[#B85C5C] text-white py-3 px-4 shadow-md" data-id="element-234">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center sm:text-left" data-id="element-235">
        <p className="text-sm sm:text-base font-medium font-sans tracking-wide" data-id="element-236">
          ¡OFERTA DE LANZAMIENTO! Consigue el Método Reseteo Hormonal H2 + los
          15 Bonos de Regalo (Ahorra un 93%)
        </p>
        <div className="flex items-center gap-2 bg-white/20 px-3 py-1 rounded-full animate-pulse-slow" data-id="element-237">
          <ClockIcon className="w-4 h-4" data-id="element-238" />
          <span className="font-bold font-sans tracking-wider text-sm" data-id="element-239">
            {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
            {formatTime(timeLeft.seconds)}
          </span>
        </div>
      </div>
    </div>;
}